/* ============================================================================
 * ตัวเลือกและตัวช่วยของหน้า "สมัครเป็นพาร์ตเนอร์" (/partner)
 *
 * ไฟล์นี้เก็บเฉพาะสิ่งที่ไม่ใช่ UI — ลำดับขั้นตอน ตัวเลือกคงที่ กติกาการตรวจค่า
 * และตัวช่วยเล็ก ๆ ที่ทั้งฟอร์มกับหน้าสรุปใช้ร่วมกัน เพื่อให้คอมโพเนนต์แต่ละขั้น
 * เหลือแต่การวางหน้าจอล้วน ๆ
 *
 * ต่อกับ API แล้ว (services/partner.service.js) — ตัวตรวจค่าในไฟล์นี้เป็นด่านหน้า
 * ที่ทำให้ผู้กรอกเห็นข้อผิดพลาดใต้ช่องทันทีโดยไม่ต้องรอ round trip ส่วนด่านจริง
 * อยู่ฝั่ง backend (partner-apply.dto.js + partner.service.js) กติกาสองฝั่งต้องตรงกัน
 * ถ้าแก้ที่นี่ต้องไปแก้อีกฝั่งด้วย ไม่งั้นจะกรอกผ่านหน้าเว็บแล้วโดนปฏิเสธตอนกดส่ง
 * ========================================================================== */
/* ------------------------------------------------------------- ลำดับขั้นตอน */
/* 4 ขั้นตามที่ผู้ใช้เห็นบนแถบความคืบหน้า — ขั้นสุดท้ายเป็นผลลัพธ์ ไม่ใช่ฟอร์ม
   จึงไม่มีปุ่มย้อนกลับ (ส่งใบสมัครแล้วแก้ไขเองไม่ได้ ต้องติดต่อผู้ดูแล) */
export const PARTNER_STEPS = [
  { key: "profile", label: "partner_step_profile", desc: "partner_step_profile_desc" },
  { key: "verify", label: "partner_step_verify", desc: "partner_step_verify_desc" },
  { key: "terms", label: "partner_step_terms", desc: "partner_step_terms_desc" },
  { key: "done", label: "partner_step_done", desc: "partner_step_done_desc" },
];

export const STEP_INDEX = PARTNER_STEPS.reduce((map, step, i) => ({ ...map, [step.key]: i }), {});

/* ----------------------------------------------------- ประสบการณ์ / ความถนัด */
/* ระดับประสบการณ์เป็นช่วงปี ไม่ให้พิมพ์เอง เพราะผู้ดูแลต้องเอาไปคัดกรองเป็นกลุ่ม */
export const EXPERIENCE_OPTIONS = [
  { value: "none", label: "partner_exp_none" },
  { value: "lt1", label: "partner_exp_lt1" },
  { value: "1to3", label: "partner_exp_1to3" },
  { value: "3to5", label: "partner_exp_3to5" },
  { value: "gt5", label: "partner_exp_gt5" },
];

/* ความเชี่ยวชาญเลือกได้หลายข้อ (ชิป) — ใช้จับคู่ผู้สมัครกับทรัพย์ที่ดูแลอยู่
   ไม่บังคับ เพราะมือใหม่ยังไม่รู้ว่าตัวเองถนัดอะไร */
export const EXPERTISE_OPTIONS = [
  { value: "condo", label: "partner_expertise_condo" },
  { value: "house", label: "partner_expertise_house" },
  { value: "townhome", label: "partner_expertise_townhome" },
  { value: "land", label: "partner_expertise_land" },
  { value: "commercial", label: "partner_expertise_commercial" },
  { value: "rent", label: "partner_expertise_rent" },
  { value: "project", label: "partner_expertise_project" },
  { value: "luxury", label: "partner_expertise_luxury" },
];

/* --------------------------------------------------------- เอกสารยืนยันตัวตน */
/* ทั้งสองชนิดขอแค่ด้านหน้าใบเดียว — ด้านหน้ามีรูปถ่าย ชื่อ-สกุล และเลขประจำตัว
   ครบพอให้ผู้ดูแลตรวจตัวตนได้แล้ว ขอเอกสารเพิ่มทีละใบมีแต่ทำให้คนกรอกไม่จบ
   (ถ้าภายหลังต้องการหลังบัตรหรือรูปถ่ายคู่เอกสาร เพิ่ม slot ในตารางนี้ที่เดียวพอ
   ตัวตรวจค่าและหน้าจอไล่ตามรายการนี้อยู่แล้ว) */
export const DOC_TYPES = [
  { value: "id_card", label: "partner_doc_id_card" },
  { value: "passport", label: "partner_doc_passport" },
];

export const DOC_SLOTS = {
  id_card: [{ key: "front", label: "partner_doc_id_front", required: true }],
  passport: [{ key: "front", label: "partner_doc_passport_page", required: true }],
};

/* รับเฉพาะภาพถ่ายกับ PDF และคุมขนาดให้เล็กกว่าเพดานอัปโหลดของระบบ (15MB)
   เพราะเอกสารยืนยันตัวตนคือรูปถ่ายหน้าเดียว ไฟล์ใหญ่กว่านี้คือถ่ายมาเกินจำเป็น */
export const DOC_ACCEPT = "image/jpeg,image/png,image/webp,application/pdf";
export const DOC_MAX_SIZE = 10 * 1024 * 1024;
const DOC_MIME = ["image/jpeg", "image/png", "image/webp", "application/pdf"];

/** ตรวจไฟล์ที่เพิ่งเลือก — คืนคีย์ข้อความผิดพลาด หรือค่าว่างเมื่อผ่าน */
export const docFileError = (file) => {
  if (!file) return "";
  if (!DOC_MIME.includes(file.type)) return "partner_doc_invalid_type";
  if (file.size > DOC_MAX_SIZE) return "partner_doc_too_large";
  return "";
};

/** "1.2 MB" — ใช้โชว์ใต้ชื่อไฟล์ที่แนบแล้ว */
export const fileSize = (bytes) => {
  const mb = Number(bytes || 0) / (1024 * 1024);
  return mb >= 1 ? `${mb.toFixed(1)} MB` : `${Math.max(1, Math.round(Number(bytes || 0) / 1024))} KB`;
};

/* ------------------------------------------------------------ รูปโปรไฟล์ */
/* ไม่บังคับ — เป็นรูปที่ลูกค้าจะเห็นคู่กับประกาศของพาร์ตเนอร์รายนี้หลังได้รับอนุมัติ
   (ตอนอนุมัติระบบคัดลอกไปเป็น users.picture ให้เลย ไม่ต้องอัปซ้ำ)

   รับเฉพาะภาพถ่าย ไม่รับ PDF ต่างจากเอกสารยืนยันตัวตน — ปลายทางของรูปนี้คือ
   <img> บนหน้าเว็บสาธารณะ ไฟล์ที่โชว์เป็นรูปไม่ได้จึงไม่มีประโยชน์ตั้งแต่ต้น */
export const PICTURE_ACCEPT = "image/jpeg,image/png,image/webp";
export const PICTURE_MAX_SIZE = 5 * 1024 * 1024;
const PICTURE_MIME = ["image/jpeg", "image/png", "image/webp"];

/* ขนาดที่แนะนำ — บอกเป็นจัตุรัสเพราะกรอบที่แสดงผลเป็นวงกลม รูปสี่เหลี่ยมผืนผ้า
   จะถูกครอบตัดขอบทิ้ง (object-fit: cover) แล้วผู้สมัครจะงงว่าทำไมรูปไม่เหมือนที่เลือก */
export const PICTURE_RECOMMEND = "400 x 400 px";

/** ตรวจรูปที่เพิ่งเลือก — คืนคีย์ข้อความผิดพลาด หรือค่าว่างเมื่อผ่าน */
export const pictureFileError = (file) => {
  if (!file) return "";
  if (!PICTURE_MIME.includes(file.type)) return "partner_picture_invalid_type";
  if (file.size > PICTURE_MAX_SIZE) return "partner_picture_too_large";
  return "";
};

/* --------------------------------------------------------- บัญชีรับเงิน */
/* รายชื่อธนาคารไม่ได้อยู่ในไฟล์นี้ — ใช้ global.bank (components/global.js) ชุดเดียว
   กับบัญชีบริษัทในหน้า ตั้งค่าเหรียญ จะได้ไม่มีรายชื่อธนาคารสองชุดให้ต้องคอยดูแลให้ตรงกัน

   เลขบัญชีให้พิมพ์ขีดคั่นได้ (123-4-56789-0) เพราะคนคัดลอกมาจากสมุดบัญชี/แอปธนาคาร
   ตามรูปแบบที่เห็น การบังคับให้ลบขีดออกเองมีแต่ทำให้กรอกไม่ผ่านโดยไม่ได้ข้อมูลดีขึ้น
   กติกาต้องตรงกับ partner-apply.dto.js ฝั่ง backend */
export const BANK_ACCOUNT_MIN_DIGITS = 8;
export const BANK_ACCOUNT_MAX_DIGITS = 20;

/** นับเฉพาะตัวเลขในเลขบัญชี — ใช้ทั้งตอนตรวจค่าและตอนจำกัดความยาวที่ช่องกรอก */
export const accountDigits = (value) => String(value || "").replace(/[^0-9]/g, "");

/* ------------------------------------------------------------------- OTP */
/* ค่าทั้งสามต้องตรงกับ partner.constant.js ฝั่ง backend — ที่นี่ใช้แค่วาดตัวนับถอยหลัง
   บนหน้าจอ ส่วนการบังคับใช้จริง (หมดอายุ / ขอถี่เกินไป / กรอกผิดเกินโควตา) อยู่ที่ server
   ซึ่งเป็นที่เดียวที่เชื่อถือได้ — คนที่ยิง API ตรงไม่ได้ผ่านตัวนับพวกนี้เลย */
export const OTP_LENGTH = 6;
export const OTP_RESEND_SEC = 60;   // กันกดขอรหัสรัว ๆ
export const OTP_EXPIRE_SEC = 300;  // 5 นาที — พอให้เปิดกล่องจดหมาย (รวมถังขยะ) ทันโดยไม่ค้างนานเกินไป
export const OTP_MAX_ATTEMPT = 5;   // ใส่ผิดเกินนี้ต้องขอรหัสใหม่

/** "mm:ss" สำหรับนับถอยหลังอายุรหัส */
export const countdown = (seconds) => {
  const safe = Math.max(0, Math.floor(seconds));
  return `${String(Math.floor(safe / 60)).padStart(2, "0")}:${String(safe % 60).padStart(2, "0")}`;
};

/** ปิดชื่อกล่องจดหมายไว้บางส่วน name@email.com -> na•••@email.com
    (โชว์ในข้อความว่าส่งรหัสไปที่ไหน — พอให้ผู้ใช้จำได้ว่าเป็นอีเมลตัวเอง
    แต่ถ้ามีคนมองจอตอนกรอกก็ไม่ได้อีเมลเต็มไปด้วย ส่วนโดเมนไม่ปิด
    เพราะเป็นตัวบอกว่าต้องไปเปิดกล่องจดหมายของเจ้าไหน) */
export const maskEmail = (email) => {
  const value = String(email || "").trim();
  const at = value.lastIndexOf("@");
  if (at < 1) return value;

  const name = value.slice(0, at);
  const domain = value.slice(at);
  // ชื่อสั้น 1-2 ตัวโชว์ได้แค่ตัวแรก ไม่งั้นเท่ากับไม่ได้ปิดอะไรเลย
  const keep = name.length <= 2 ? 1 : 2;
  return `${name.slice(0, keep)}${"•".repeat(Math.max(3, name.length - keep))}${domain}`;
};

/** ปิดเบอร์ตรงกลางไว้ 0812345678 -> 081-xxx-5678 (ใช้ในหน้าสรุปหลังส่งใบสมัคร) */
export const maskPhone = (phone) => {
  const digits = String(phone || "").replace(/[^0-9]/g, "");
  if (digits.length < 7) return digits;
  return `${digits.slice(0, 3)}-xxx-${digits.slice(-4)}`;
};

/* -------------------------------------------------------------- รหัสผ่าน */
/* ต้องตรงกับ PASSWORD_MIN_LENGTH ใน user.constant.js ฝั่ง backend — บัญชีที่ออกให้
   ตอนอนุมัติเป็นแถวในตาราง users เหมือนผู้ใช้ภายใน จึงใช้กติกาเดียวกันทั้งระบบ */
export const PASSWORD_MIN_LENGTH = 8;

/* --------------------------------------------------------------- ค่าเริ่มต้น */
export const EMPTY_PARTNER_FORM = {
  // ข้อมูลส่วนตัว
  name: "",
  email: "",
  phone: "",
  line_id: "",
  /* รูปโปรไฟล์ที่เลือกไว้ { name, size, type, url, file } — url เป็น object URL
     ไว้พรีวิวเท่านั้น ไฟล์จริงถูกอัปตอนกดส่งพร้อมเอกสาร ด้วยเหตุผลเดียวกัน
     (เลือกไว้แล้วปิดแท็บหนีจะได้ไม่ทิ้งไฟล์ค้างในบักเก็ตโดยไม่มีใบสมัครผูกอยู่) */
  picture: null,
  // บัญชีรับเงิน — บังคับกรอก ระบบใช้โอนค่าคอมมิชชั่นกลับให้พาร์ตเนอร์
  bank: "",
  bank_account_no: "",
  bank_account_name: "",
  // ที่อยู่
  address: "",
  province: "",
  district: "",
  subdistrict: "",
  postcode: "",
  // ประสบการณ์
  experience: "",
  license: "",
  expertise: [],
  about: "",
  /* รหัสผ่านของบัญชีที่จะได้ใช้เมื่อใบสมัครผ่านการอนุมัติ
     ให้ตั้งเองตั้งแต่ตอนสมัคร ไม่ใช่ให้ระบบสุ่มแล้วส่งทางอีเมลตอนอนุมัติ เพราะ
     รหัสผ่านที่ค้างอยู่ในกล่องจดหมายคือรหัสผ่านที่รั่วได้ตลอดอายุของกล่องนั้น
     และผู้สมัครก็ไม่ต้องรอเมลอีกฉบับหลังได้รับอนุมัติ */
  password: "",
  password_confirm: "",
  // ยืนยันตัวตน
  email_verified: false,
  doc_type: "id_card",
  docs: {}, // { [slot]: { name, size, type, url } } — url เป็น object URL ไว้พรีวิวเท่านั้น
  // ข้อกำหนด
  accept_terms: false,
  accept_pdpa: false,
};

/* ------------------------------------------------------------- การตรวจค่า */
/* คืนเป็น { field: "คีย์ข้อความ" } เพื่อให้ฟอร์มขึ้นข้อความใต้ช่องที่ผิดได้ทีละช่อง
   ฟอร์มยาวแบบนี้ถ้าเด้งป๊อปอัปทีละข้อ ผู้ใช้จะไม่รู้ว่าต้องกลับไปแก้ช่องไหน */
export const validateProfile = (form) => {
  const errors = {};
  const phone = String(form.phone || "").replace(/[^0-9]/g, "");

  if (!String(form.name || "").trim()) errors.name = "partner_require_name";
  if (!String(form.email || "").trim()) errors.email = "partner_require_email";
  else if (!/^\S+@\S+\.\S+$/.test(form.email.trim())) errors.email = "partner_invalid_email";

  if (!phone) errors.phone = "partner_require_phone";
  // เบอร์มือถือไทย 10 หลักขึ้นต้น 0 — ผู้ดูแลติดต่อกลับทางโทรศัพท์/แชท ไม่ใช่เบอร์บ้านหรือเบอร์ออฟฟิศ
  else if (!/^0[689]\d{8}$/.test(phone)) errors.phone = "partner_invalid_phone";

  if (!String(form.line_id || "").trim()) errors.line_id = "partner_require_line";

  if (!String(form.address || "").trim()) errors.address = "partner_require_address";
  if (!form.province) errors.province = "partner_require_province";
  if (!form.district) errors.district = "partner_require_district";
  if (!form.subdistrict) errors.subdistrict = "partner_require_subdistrict";
  if (!/^\d{5}$/.test(String(form.postcode || ""))) errors.postcode = "partner_require_postcode";
  if (!form.experience) errors.experience = "partner_require_experience";

  /* บัญชีรับเงินบังคับครบทั้งสามช่อง — บัญชีที่ขาดช่องใดช่องหนึ่งโอนเงินไม่ได้จริง
     เก็บมาครึ่งเดียวจึงเท่ากับไม่ได้เก็บ */
  if (!form.bank) errors.bank = "partner_require_bank";
  const account = accountDigits(form.bank_account_no);
  if (!account) errors.bank_account_no = "partner_require_account_no";
  else if (!/^[0-9][0-9\s-]*$/.test(String(form.bank_account_no).trim())) errors.bank_account_no = "partner_invalid_account_no";
  else if (account.length < BANK_ACCOUNT_MIN_DIGITS || account.length > BANK_ACCOUNT_MAX_DIGITS) {
    errors.bank_account_no = "partner_invalid_account_no";
  }
  if (!String(form.bank_account_name || "").trim()) errors.bank_account_name = "partner_require_account_name";

  /* รหัสผ่านต้องตรวจตั้งแต่ขั้นแรก ไม่ใช่ตอนกดส่ง — ผู้สมัครที่ผ่านไปถึงขั้นอัปเอกสาร
     แล้วค่อยถูกตีกลับมาแก้รหัสผ่าน จะเสียเวลาไปกับการเลื่อนหน้ากลับไปกลับมา */
  if (!form.password) errors.password = "partner_require_password";
  else if (String(form.password).length < PASSWORD_MIN_LENGTH) errors.password = "partner_password_short";
  else if (form.password !== form.password_confirm) errors.password_confirm = "partner_password_mismatch";

  return errors;
};

export const validateVerify = (form) => {
  const errors = {};
  if (!form.email_verified) errors.otp = "partner_otp_required";

  const missing = (DOC_SLOTS[form.doc_type] || [])
    .filter((slot) => slot.required && !form.docs[slot.key])
    .map((slot) => slot.key);
  if (missing.length) errors.docs = "partner_doc_required";

  return errors;
};

export const validateTerms = (form) => {
  const errors = {};
  if (!form.accept_terms) errors.accept_terms = "partner_terms_required";
  if (!form.accept_pdpa) errors.accept_pdpa = "partner_pdpa_required";
  return errors;
};

/** ตรวจทั้งใบสมัคร — ใช้ตอนกดส่งจริง กันกรณีย้อนกลับไปแก้แล้วทำให้ขั้นก่อนหน้าไม่ครบ */
export const firstInvalidStep = (form) => {
  if (Object.keys(validateProfile(form)).length) return "profile";
  if (Object.keys(validateVerify(form)).length) return "verify";
  if (Object.keys(validateTerms(form)).length) return "terms";
  return "";
};

/* ------------------------------------------------------------ ส่งขึ้น API */
/**
 * แปลงฟอร์มบนหน้าจอเป็น payload ของ POST partner/apply
 *
 * ชื่อฟิลด์ฝั่งหน้าเว็บกับฝั่งฐานข้อมูลไม่ตรงกันทุกตัว (name → full_name,
 * license → license_no) เพราะหน้าจอตั้งชื่อตามที่ผู้ใช้เห็น ส่วนตารางตั้งชื่อ
 * ตามความหมายในระบบ การแปลงรวมไว้ที่นี่ที่เดียวจะได้ไม่กระจายอยู่ในคอมโพเนนต์
 *
 * @param {object} form      ฟอร์มทั้งใบ
 * @param {string} applyToken ตั๋วที่ได้ตอนยืนยัน OTP สำเร็จ
 * @param {Array}  docs      เอกสารที่อัปขึ้น R2 แล้ว [{ slot, file_path, ... }]
 * @param {string} picture   URL รูปโปรไฟล์ที่อัปขึ้น R2 แล้ว (ว่างได้ ไม่บังคับ)
 */
export const toApplyPayload = (form, applyToken, docs = [], picture = "") => ({
  apply_token: applyToken,

  full_name: String(form.name || "").trim(),
  email: String(form.email || "").trim(),
  phone: String(form.phone || "").replace(/[^0-9]/g, ""),
  line_id: String(form.line_id || "").trim(),
  /* ไม่ได้แนบรูปก็ต้องไม่มีคีย์นี้เลย ไม่ใช่ส่งค่าว่าง — DTO ฝั่ง backend เป็น
     .strict() และ picture ต้องเป็น URL ที่ถูกต้อง ส่ง "" ไปจะถูกปฏิเสธทั้งใบ */
  ...(picture ? { picture } : {}),

  bank: form.bank,
  bank_account_no: String(form.bank_account_no || "").trim(),
  bank_account_name: String(form.bank_account_name || "").trim(),

  address: String(form.address || "").trim(),
  province: form.province,
  district: form.district,
  subdistrict: form.subdistrict,
  postcode: String(form.postcode || ""),

  experience: form.experience,
  license_no: String(form.license || "").trim(),
  expertise: form.expertise || [],
  about: String(form.about || "").trim(),

  password: form.password,

  doc_type: form.doc_type,
  docs,

  /* ส่งเป็น true ตรง ๆ ไม่ใช่ค่าจากฟอร์ม — ปุ่มส่งถูกปิดไว้จนกว่าจะติ๊กครบทั้งสองข้อ
     และ DTO ฝั่ง backend รับเฉพาะ true เท่านั้น (z.literal(true)) ส่ง false ไปก็ถูกปฏิเสธ
     ตัว server เป็นคนประทับเวลาที่ยอมรับลงคอลัมน์ accept_*_at ไม่เชื่อเวลาจากเครื่องผู้ใช้ */
  accept_terms: true,
  accept_pdpa: true,
});

/* ขั้นตอนหลังส่งใบสมัคร — บอกให้ผู้สมัครรู้ว่าเหลืออะไรอีกและใช้เวลาราวเท่าไร
   ใช้สองที่ : หน้าจบของฟอร์ม (ค้างที่ข้อแรกเสมอ เพราะเพิ่งส่ง) และหน้าติดตามสถานะ
   (ขั้นปัจจุบันคิดจากสถานะจริงที่ API ส่งมา ดู statusStep) */
export const PARTNER_STATUS_STEPS = [
  { key: "submitted", label: "partner_track_submitted", desc: "partner_track_submitted_desc" },
  { key: "reviewing", label: "partner_track_reviewing", desc: "partner_track_reviewing_desc" },
  { key: "approved", label: "partner_track_approved", desc: "partner_track_approved_desc" },
];

/* ชื่อเดิมที่หน้าจบของฟอร์มใช้อยู่ — คงไว้เพื่อไม่ต้องไล่แก้ทุกที่ที่อ้างถึง */
export const REVIEW_TIMELINE = PARTNER_STATUS_STEPS;

/* สถานะจาก API → ขั้นที่อยู่บนแถบความคืบหน้า
   pending/reviewing ยังอยู่ระหว่างตรวจ จึงชี้ที่ขั้น "กำลังตรวจสอบ" เหมือนกัน
   ต่างกันตรงข้อความสถานะด้านบนแถบ ซึ่งบอกละเอียดกว่าอยู่แล้ว
   suspended เคยผ่านครบทุกขั้นมาแล้ว จึงถือว่าอยู่ขั้นสุดท้าย */
const STATUS_STEP = { pending: 1, reviewing: 1, approved: 2, suspended: 2 };
export const statusStep = (status) => STATUS_STEP[status] ?? 0;

/* โทนสีของแถบผลลัพธ์ — ต้องตรงกับคลาส .hm-pt-result__head--* ใน partner.css */
const STATUS_TONE = {
  pending: "wait",
  reviewing: "wait",
  approved: "ok",
  rejected: "bad",
  suspended: "bad",
};
export const statusTone = (status) => STATUS_TONE[status] || "wait";
